import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ searchQuery, onClearSearch }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 px-4">
      <div className="w-16 h-16 md:w-20 md:h-20 bg-muted rounded-full flex items-center justify-center mb-4 md:mb-6">
        <Icon name="Search" size={32} color="var(--color-muted-foreground)" />
      </div>
      
      <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-2 text-center">
        No templates found
      </h3>
      
      <p className="text-sm md:text-base text-muted-foreground text-center max-w-md mb-6">
        {searchQuery
          ? `We couldn't find any templates matching "${searchQuery}". Try adjusting your search or browse all templates.`
          : 'No templates available in this category. Try selecting a different category or search for specific templates.'
        }
      </p>

      {searchQuery && (
        <Button
          variant="outline"
          size="default"
          iconName="X"
          iconPosition="left"
          onClick={onClearSearch}
        >
          Clear Search
        </Button>
      )}
    </div>
  );
};

export default EmptyState;